import React from 'react';

import { Separator } from '@change-corgi/design-system-legacy/components/content';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

/**
 * Renders the horizontal line separator that divides sections of the page. The boundaries of a "section" may or may not
 * be clear from how the code is organized, but this line and its extra vertical spacing should make it clear visually.
 * Smaller units of content on the page can use Separator without the extra spacing rules this component provides.
 *
 * Note: If a section is conditionally rendered (for example, hidden when there is no data) then you need to make sure
 * its separator is hidden when appropriate. Otherwise you can end up with two separator lines around a chunk of blank
 * space. Usually the solution. Usually the easiest way to implement this is to render SectionSeparator _within_ the
 * conditional section as the _first_ child.
 */
export const SectionSeparator: React.FC = () => {
	const isSunriseTheme = useIsSunriseTheme();

	return (
		<Separator
			role="presentation"
			sx={
				isSunriseTheme
					? {
							marginTop: ['sunrise.14', 'sunrise.20'],
							marginBottom: 'sunrise.8',
						}
					: {
							marginY: 24,
						}
			}
		/>
	);
};
